import React, { useEffect, useRef } from "react";

export default function MessagesListContainer({
  children,
  dependencyArray = [],
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, dependencyArray);

  return (
    <div ref={ref} className="body">
      {children}
    </div>
  );
}
